<template>
  <tr>
    <td>
      <span
        class="badge badge-green"
        :class="{
          'badge-green': model.status.isActive(),
          'badge-grey': !model.status.isActive(),
          'badge-red': model.status.isCancelled()
        }"
        >{{ model.status.frontend_name }}</span
      >
    </td>
    <td v-if="column_dict['contract_number']">{{ model.contract_number }}</td>
    <td v-if="column_dict['order_number']">{{ model.order_number }}</td>
    <td v-if="column_dict['depot.name']">
      {{ model.depot_drop_off ? model.depot_drop_off.name : "-" }}
    </td>
    <td v-if="column_dict['issuer_name']">
      {{
        model.event_log_vehicle_issue ? model.event_log_vehicle_issue.data?.name : "-"
      }}
    </td>
    <td v-if="column_dict['intaker_name']">
      {{
        model.eventLogVehicleIssue
          ? model.event_log_vehicle_take_in.data?.name
          : "-"
      }}
    </td>

    <td v-if="column_dict['client.company.name']">
      {{ model.client.company.name }}
    </td>
    <td v-if="column_dict['leaseCompany.company.name']">
      {{ model.lease_company ? model.lease_company.company.name : "" }}
    </td>
    <td v-if="column_dict['dealers_names']">
      {{ model.dealers_names || "" }}
    </td>
    <td v-if="column_dict['credit_type']">{{ model.credit_type }}</td>
    <td v-if="column_dict['vehicle.segment.name']">
      <span
        class="car__title__segment"
        :style="
          model.vehicle.segment && model.vehicle.segment.color
            ? {
                'background-color': model.vehicle.segment.color.hex,
                color: model.vehicle.segment.color.text_color + ' !important'
              }
            : null
        "
      >
        {{ model.vehicle.segment && model.vehicle.segment.name }}
      </span>
    </td>
    <td v-if="column_dict['vehicle.license_plate_formatted']">
      <span
        class="license"
        :class="model.vehicle.country ? model.vehicle.country.iso_3166_2 : 'nl'"
      >
        {{ model.vehicle.license_plate_formatted }}
      </span>
    </td>
    <td v-if="column_dict['vehicle.display_name']">
      {{ model.vehicle.display_name }}
    </td>
    <td v-if="column_dict['conkedOutVehicle.display_name']">
      <span v-if="model.conked_out_vehicle">{{
        model.conked_out_vehicle.display_name
      }}</span>
    </td>
    <td v-if="column_dict['conkedOutVehicle.license_plate_formatted']">
      <span
        v-if="model.conked_out_vehicle"
        class="license"
        :class="model.vehicle.country ? model.vehicle.country.iso_3166_2 : 'nl'"
      >
        {{ model.conked_out_vehicle.license_plate_formatted }}
      </span>
    </td>
    <td v-if="column_dict['start_datetime']">
      {{ model.start_datetime | datetime }}
    </td>
    <td v-if="column_dict['duration_in_days']">{{ model.duration_in_days }}</td>
    <td
      v-if="column_dict['end_datetime']"
      :data-tooltip="model.first_extension && model.first_extension.note"
    >
      {{ model.end_datetime | datetime }}
    </td>
    <td v-if="column_dict['signed_off_at']">
      {{ model.signed_off_at | datetime }}
    </td>
    <td>
      <div class="btn-group" role="group">
        <a
          v-if="model.is_extendable"
          href="#"
          class="refresh"
          :data-tooltip="i18n.app.common.extend"
          @click="onExtendClick"
        >
          <i class="cs-refresh"></i>
        </a>
        <a
          v-if="model.is_sign_offable"
          @click="onSignOffClick"
          href="#"
          class="delete"
          :data-tooltip="i18n.app.common.sign_off"
        >
          <i class="cs-logout"></i>
        </a>
        <a
          v-if="model.is_cancellable"
          @click="onCancelClick"
          href="#"
          class="delete"
          :data-tooltip="i18n.app.common.delete"
        >
          <i class="cs-delete"></i>
        </a>
        <router-link
          v-if="canCancel"
          tag="a"
          :to="{ name: 'contract-edit', params: { id: model.id } }"
          class="edit"
        >
          <i class="cs-edit"></i>
        </router-link>
        <a
          v-if="canEditOrderNumber"
          @click="onEditContractNumberClick"
          href="#"
          class="edit"
        >
          <i class="cs-edit"></i>
        </a>
        <router-link
          v-if="model.is_openable !== false"
          tag="a"
          :to="{ name: 'contract-edit', params: { id: model.id } }"
          class="view"
        >
          <i class="cs-arrow-right"></i>
        </router-link>
      </div>
    </td>
    <b-modal
      v-if="model.is_extendable"
      ref="contract-extend-modal"
      title="Contract verlengen"
      id="contract-extend-modal"
      hide-footer
    >
      <ContractExtensionEdit :contract="model" @save="onContractExtended" />
    </b-modal>
  </tr>
</template>

<script>
import modelListItemMixin from "@/components/crud/mixins/model-list-item.mixin";
import ContractExtensionEdit from "@/components/crud/contract-extension/ContractExtensionEdit";
import { mapGetters } from "vuex";

export default {
  name: "contract-item",
  props: ["column_dict"],
  mixins: [modelListItemMixin],
  data() {
    return {
      // columns: columns
    };
  },
  mounted() {
    this.setDefaultCountry();
  },
  components: {
    ContractExtensionEdit
  },
  methods: {
    onEditClick() {
      this.$router.push(`/contracts/${this.model.id}/edit`);
    },
    onViewClick() {
      this.$router.push(`/contracts/${this.model.id}/edit`);
    },
    onCancelClick() {
      this.$dialog
        .alert(i18n.app.common.warning, {
          view: "contract-cancel-dialog",
          html: true,
          backdropClose: true,
          model: this.model
        })
        .then(() => {
          this.$emit("cancel", this.model);
        });
    },
    onSignOffClick() {
      this.$dialog
        .alert(i18n.app.common.warning, {
          view: "contract-sign-off-dialog",
          html: true,
          backdropClose: true,
          model: this.model,
          customClass: "vue-dialog vue-dialog-centered"
        })
        .then(() => {
          this.$emit("cancel", this.model);
        });
    },
    onExtendClick() {
      this.$refs[`contract-extend-modal`].show();
    },
    onEditContractNumberClick() {
      this.$dialog
        .alert(i18n.app.common.warning, {
          view: "contract-edit-order-number-dialog",
          html: true,
          backdropClose: true,
          model: this.model,
          customClass: "vue-dialog vue-dialog-centered"
        })
        .then(model => {
          this.$emit("update", this.model, model.data);
        });
    },
    onContractExtended(contractExtension) {
      this.model.end_datetime = contractExtension.end_datetime;
    },
    setDefaultCountry() {
      if (this.model?.person?.address?.country_id) {
        this.model.address_return.country_id = this.model?.person?.address?.country_id;
        this.$forceUpdate();
      }
    }
  },
  computed: {
    canExtend() {
      return this.model.is_extendable && !this._hasReadonlyRole;
    },
    canSignOff() {
      return this.model.is_sign_offable && !this._hasReadonlyRole;
    },
    canDelete() {
      return this.model.is_cancellable && !this._hasReadonlyRole;
    },
    canCancel() {
      return this.model.is_cancellable && !this._hasReadonlyRole;
    },
    canEditOrderNumber() {
      return this.model.is_order_number_editable && !this._hasReadonlyRole;
    }
  }
};
</script>
